import { getApp } from "firebase/app";
import { getFunctions, type Functions } from "firebase/functions";
import { useMemo } from "react";

export function useFirebaseFunctions(): Functions | undefined {
  return useMemo(() => {
    try {
      return getFunctions(getApp());
    } catch {
      return undefined;
    }
  }, []);
}
